export default __webpack_public_path__ + "static/VehicleListWithAdds-a7c3f29b3b37c88ce14b907be4af93f8.jpg";